import React from 'react'

/**
 * Handle outside click
 */
const useOutsideClick = (callback: () => void) => {
  const ref = React.useRef<any>()
  const callbackRef = React.useRef(callback)
  callbackRef.current = callback

  React.useEffect(() => {
    const handleClick = (e: any) => {
      if (ref.current && !ref.current.contains(e.target)) {
        callbackRef.current()
      }
    }
    document.addEventListener('click', handleClick)
    return () => document.removeEventListener('click', handleClick)
  }, [])

  return ref
}

export default useOutsideClick